import React from 'react';

interface CloseIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const CloseIcon: React.FC<CloseIconProps> = ({
  width = 24,
  height = 24,
  color = 'currentColor',
  className,
  style,
  title,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      role="img"
      aria-hidden={!title}
      aria-label={title}
    >
      {title && <title>{title}</title>}
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseIcon;
